import React from 'react';
import './index.scss';

interface IProps {
  rows?: number;
  gap?: number | number[];
  width?: string | string[];
  height?: string | string[];
  horizontal?: 'rtl' | 'ltr';
  className?: string;
}

export const Skeleton = (props: IProps) => {
  let gapClass = '';
  if (props.gap && !Array.isArray(props.gap)) {
    gapClass = `gap-y-[${props.gap}px]`;
  } else if (!props.gap) {
    gapClass = 'gap-y-4';
  }

  if (props.horizontal === 'rtl') {
    gapClass += ` direction-rtl`;
  }

  return (
    <div
      dir={props.horizontal === 'rtl' ? 'rtl' : 'ltr'}
      className={`skeleton-container ${gapClass} direction-rtl ${props.className ?? ''}`}
      style={{
        width: !props.width ? '100%' : !Array.isArray(props.width) ? props.width : '100%',
        height: !props.height ? '20px' : !Array.isArray(props.height) ? props.height : '20px',
      }}
    >
      {Array.from({ length: props.rows ?? 3 }).map((_, index) => (
        <div
          style={{
            marginBottom: Array.isArray(props.gap) && props.gap[index] ? props.gap[index] + 'px' : '0',
            width: Array.isArray(props.width) && props.width[index] ? props.width[index] : '100%',
            height: Array.isArray(props.height) && props.height[index] ? props.height[index] : '100%',
          }}
          className={`w-full skeleton skeleton__description rounded`}
          key={index}
        ></div>
      ))}
    </div>
  );
};
